import React, { useState, useEffect } from 'react';
import { Swipeable } from 'react-swipeable';
import styled from '@emotion/styled';
import { onSwipeLeft, onSwipeRight, applyTransition, } from '@nykaa/deals-utils/slider';
import Dots from './dots';
const SlidesContainer = styled.div `
  height: 100%;
  width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
`;
const SlideWrapper = styled.div `
  align-items: center;
  flex: 0 0 auto;
  width: 100%;
  text-align: center;
  display: flex;
`;
const LeftArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/3df01759-af0c-4d81-b2f7-f61577ac3807.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  left: 8px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
const RightArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/45d5a7b6-86eb-4850-9568-4d6ed91731fe.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  right: 6px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
const Carousel = (widgetData) => {
    const { params, children, id, isDesktop, } = widgetData;
    const { delayTimer, } = params;
    const [activeSlide, changeSlide] = useState(0);
    const [intervalState, setIntervalState] = useState(null);
    const slides = children;
    const slidesLength = slides.length;
    const swipeRightHandler = () => {
        changeSlide(onSwipeRight(activeSlide, slidesLength));
        setIntervalState(clearInterval(intervalState));
    };
    const swipeLeftHandler = () => {
        changeSlide(onSwipeLeft(activeSlide, slidesLength));
        setIntervalState(clearInterval(intervalState));
    };
    const rightClickHandler = () => {
        const newSlide = activeSlide + 1;
        if (newSlide < slidesLength) {
            changeSlide(newSlide);
        }
        else {
            changeSlide(0);
        }
    };
    const leftClickHandler = () => {
        const newSlide = activeSlide - 1;
        if (newSlide >= 0) {
            changeSlide(newSlide);
        }
        else {
            changeSlide(slidesLength - 1);
        }
    };
    const clearAutoplay = () => {
        if (!delayTimer) {
            return;
        }
        setIntervalState(clearInterval(intervalState));
    };
    const setAutoplay = () => {
        if (!delayTimer) {
            return;
        }
        const interval = setInterval(() => {
            swipeLeftHandler();
        }, delayTimer);
        setIntervalState(interval);
    };
    useEffect(() => {
        clearAutoplay();
        applyTransition(activeSlide, id, 0.15);
        setAutoplay();
    }, [activeSlide]);
    return (React.createElement("div", null,
        React.createElement(Swipeable, { onSwipedRight: () => swipeRightHandler(), onSwipedLeft: () => swipeLeftHandler(), delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: true, trackMouse: true, rotationAngle: 0, style: { height: '90%', width: '100%' } },
            React.createElement(SlidesContainer, null,
                (isDesktop && slidesLength > 1) && React.createElement(LeftArrow, { onClick: leftClickHandler }),
                (isDesktop && slidesLength > 1) && React.createElement(RightArrow, { onClick: rightClickHandler }),
                slides.map((slide) => (React.createElement(SlideWrapper, { className: id }, slide))))),
        React.createElement(Dots, { length: slidesLength, active: activeSlide, onClickHandler: (clickedIndex) => changeSlide(clickedIndex) })));
};
export default Carousel;
